module.exports = __webpack_public_path__ + "img/skill_level_5_svg.7ed073b0.svg";